<!-- =========================================================================================
    File Name: Regulation.vue
    Description: Displays the list of regulation's
========================================================================================== -->
<template>
    <div class="regulation">
        <div class="flex flex-wrap justify-between items-start mb-8">
            <h2 class="font-light text-lg my-3">ENREGISTRER UN REGLEMENT</h2>
        </div>

        <vs-card class="px-2">

            <!-- <vs-table id="regulations-view" search stripe max-items="10" pagination :data="regulations"> -->
            <vs-table id="regulations-view" search stripe max-items="10" pagination :data="regulations">
                <template slot="header">
                    <h3 class="h5 uppercase">
                        Vos Règlements
                    </h3>
                    <vs-button size="large" class="leading-none ml-6 px-4 py-3 text-sm" color="primary"
                               @click="regulationModal()">Importer des règlements
                    </vs-button>
                    <RegulationModal :show-modal="showRegulationModal" @close-modal="setMessage"/>
                </template>
                <template slot="thead">
                    <vs-th sort-key="date">Date de la facture</vs-th>
                    <vs-th sort-key="destinataire">Client</vs-th>
                    <vs-th sort-key="number">N° Facture</vs-th>
                    <vs-th sort-key="amount_ttc" class="montant">Montant TTC</vs-th>
                    <vs-th sort-key="actions">Actions</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(file, index) in data">
                        <vs-td :data="file.created_at">
                            <template v-if="file.created_at">
                                {{ file.created_at | moment('DD MMM YYYY') }}
                            </template>
                        </vs-td>

                        <vs-td :data="file.destinataire">
                            <template v-if="file.destinataire">
                                {{ file.destinataire.name }}
                            </template>
                        </vs-td>

                        <vs-td :data="file.number">
                            {{ file.number }}
                        </vs-td>

                        <vs-td :data="file.amount_ttc">
                            <span class="text-success text-nowrap">{{
                                    Number(file.amount_ttc) | numFormat('$ 0,0.00')
                                }}</span>&nbsp;<span class="text-muted">/</span> &nbsp;<span
                            class="text-danger text-nowrap">{{
                                Number(file.total_paid) | numFormat('$ 0,0.00')
                            }}</span>
                        </vs-td>

                        <vs-td :data="file.id" style="width: 260px;" class="px-3">
                            <vs-button size="large" class="leading-none px-6 py-3 text-sm" icon-pack="far"
                                       @click="doModalPaiement(file.id, file.client.name,file.number)"
                                       icon="fa-plus mr-3" type="gradient" color="primary">Enregistrer le paiement
                            </vs-button>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>
        </vs-card>
        <vs-prompt
            title="Enregistrer un nouveau règlement"
            @cancel="clearPaiementForm"
            @accept="acceptPaiementForm"
            accept-text="Valider"
            cancel-text="Annuler"
            :is-valid="validPaiement"
            :active.sync="activeModalPaiement">
            <div class="payment-form">

                <i class="far fa-info-circle mr-2"></i>Veuillez saisir les informations de règlement ci-dessous, pour la
                facture N° <span class="text-primary">{{ formPaiement.number }}</span>, nom du client : <span
                class="text-primary">{{ formPaiement.clientName }}</span>.

                <vs-input
                    type="number"
                    label="Montant"
                    v-model.number="formPaiement.montant"
                    class="mt-4 mb-2 w-full"
                    :danger="!Boolean(formPaiement.montant)"
                    danger-text="Vous devez indiquer un montant"
                    placeholder="montant en €"
                    val-icon-pack="feather"
                    val-icon-danger="icon-x"/>

                <div class="vs-component vs-con-input-label vs-input mt-4 mb-2 w-full vs-input-primary">
                    <label class="vs-input--label" for="dateReglement"><i class="far fa-calendar mr-1"></i> Date du
                        règlement</label>
                    <datepicker monday-first :language="fr" v-model="formPaiement.date" :value="formPaiement.date"
                                id="dateReglement" class="mt-1" :disabled-dates="{from: new Date() }"
                                placeholder="Sélectionnez une date" format="dd/MM/yyyy"></datepicker>
                </div>

                <vs-alert :active="!Boolean(formPaiement.date)" color="danger">
                    Vous devez indiquer une date de règlement
                </vs-alert>
            </div>
        </vs-prompt>

    </div>
</template>

<script>
// @ is an alias to /src

import {mapState, mapActions} from 'vuex'
import RegulationModal from '@/components/regulation/RegulationModal'
import {fr} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'


export default {
    name: 'Regulation',
    data() {
        return {
            fr,
            showRegulationModal: false,
            formPaiement: {
                clientName: '',
                number: null,
                id: null,
                montant: '',
                date: ''
            },
            activeModalPaiement: false
        }
    },
    components: {
        RegulationModal,
        Datepicker
    },
    computed: {
        ...mapState({
            regulations: state => state.bill.bills,
            regulationsLoading: state => state.bill.billsLoading
        }),
        total: {
            get() {
                return this.$store.state.bill.total
            },
            set(val) {
                this.$store.state.bill.total = val
            }
        },
        validPaiement() {
            return Boolean(this.formPaiement.id) && Boolean(this.formPaiement.montant) && this.formPaiement.date !== ''
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'Règlement') {
            this.$vs.loading()
            this.getAllBills({
                page: 1,
                limit: 100000,
                solded: false
            }).then(() => {
                next()
                this.$vs.loading.close()
            }).catch(() => {
                this.$vs.loading.close()
                next()
            })
        } else {
            next()
        }
    },
    created() {
        this.refreshList()
    },
    methods: {
        ...mapActions('bill', ['getAllBills', 'deleteBill', 'addReglementToBill']),

        refreshList() {
            this.$vs.loading()
            this.getAllBills({
                page: 1,
                limit: 100000,
                solded: false
            }).then(() => {
                this.$vs.loading.close()
            }).catch(() => {
                this.$vs.loading.close()
            })
        },

        deleteItem(id) {
            this.deleteBill(id).then(() => {
                this.refreshList()
            })
        },
        doModalPaiement(id, client, number) {
            this.formPaiement.clientName = client
            this.formPaiement.id = id
            this.formPaiement.number = number
            this.activeModalPaiement = true
        },
        clearPaiementForm() {
            this.formPaiement.clientName = ''
            this.formPaiement.id = null
            this.formPaiement.number = null
            this.formPaiement.montant = ''
            this.formPaiement.date = ''
        },

        acceptPaiementForm() {
            this.addReglementToBill(
                {
                    id: this.formPaiement.id,
                    reglement: {
                        date: this.formPaiement.date,
                        amount: this.formPaiement.montant
                    }
                }
            ).then(() => {
                this.clearPaiementForm()
                this.refreshList()
            })
        },

        regulationModal() {
            this.showRegulationModal = true
        },

        setMessage(payload) {
            this.showRegulationModal = payload.boolean
        }
    }
}
</script>

<style lang="scss">
#icon-col {
    width: 10rem;
}
</style>
